import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link, Outlet, useLocation } from 'react-router-dom'
import { RouteHolderHandler } from '../../../redux/features/Publish Article By Admin Slices/ArticleSlice';

const PublishArticleByAdminOutlet = () => {
  
  const dispatch = useDispatch();
  const location = useLocation().pathname?.split('/').splice(1)

  console.log(location);

  useEffect(()=>{
    // console.log(location?.slice(location?.length-2, location?.length-1));
  if(!location?.includes("AllArticleDetails") && !location?.includes("EditPublishNewsArticle")){
       const route = location?.[location?.length - 1];
       if(!["AllArticleDetails","PublishNewsArticle","SubCategoryList","PublishArticleByAdmin","PublishArticleByAPI"]?.includes(route))
         dispatch(RouteHolderHandler(route));
     }
  },[location])
  

  return (
    <>
  {!location?.includes('AllArticleDetails') && !location?.includes('SubCategoryList') && !location?.includes('CategoryList') && !location?.includes('PublishNewsArticle') && !location?.includes('EditPublishNewsArticle') && 
 <div className="CommonTabs">
        <ul className="nav nav-tabs">
        <li className="nav-item mb-2 ">
            <Link
              className={`nav-link ${location?.includes('AllPendingArticles') && 'active'}`}
              data-toggle="tab"
              to="AllPendingArticles"
            >
              All Pending Article
            </Link>
          </li>
          <li className="nav-item mb-2 ">
            <Link
              className={`nav-link ${location?.includes('AllPublishedArticles') && 'active'}`}
              data-toggle="tab"
              to="AllPublishedArticles"
            >
              All Published Articles 
            </Link>
          </li>
          <li className={`nav-item  mb-2`}>
            <Link className={`nav-link ${location?.includes('HiddenArticles') && 'active'}`} data-toggle="tab" to="HiddenArticles">
              Rejected Articles
            </Link>
          </li>
          <li className={`nav-item mb-2`}>
            <Link className={`nav-link  ${location?.includes('DeleteArticles') && 'active'}`} data-toggle="tab" to="DeleteArticles">
              Deleted Articles
            </Link>
          </li>
        </ul>
      </div>}
      {!location?.includes('AllArticleDetails') && !location?.includes('SubCategoryList') && !location?.includes('CategoryList') && !location?.includes('PublishNewsArticle') && !location?.includes('EditPublishNewsArticle') && 
      <div className="TitleBox">
            <h4 className="Title" />
           {!location.includes('PublishArticleByAPI') &&
            <span>
              {" "}
              <Link
                className="TitleLink"
                to={'/ContentManagement/PublishArticleByAdmin/SubCategoryList'}
              >
                Quix Dynamic
              </Link>
              {/* <Link
                className="TitleLink"
                to={'/ContentManagement/PublishArticleByAdmin/CategoryList/1'}
              >
                News Category
              </Link> */}
              <Link
                className="TitleLink" 
                to={'/ContentManagement/PublishArticleByAdmin/PublishNewsArticle'}
              >
                Publish New Article
              </Link>
            </span>
            }
          </div>
          }
      <div className="tab-content">
      <Outlet/>
      </div>  
     </>
  )
}

export default PublishArticleByAdminOutlet
